import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import {
  Card,
  CircularProgress,
  LinearProgress,
  Box,
  Typography,
  Button,
  Grid,
  CardHeader,
  CardContent,
  FormControlLabel,
  Switch,
  Collapse,
  TextField,
  CardActions,
} from "@material-ui/core";
import store from "../../stores/copyStore";
import locationStore from "../../stores/locationStore";
import CopyForm from "./CopyForm";
import { CSVLink, CSVDownload } from "react-csv";
import SaveIcon from "@material-ui/icons/Save";
import '../../styles/copy.css';

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },

  excel: {
    width: "100%",
    maxWidth: 1000,
    height: 300,
    overflow: "auto",
    marginTop: 20,
  },
  cardDiv: {
    maxWidth: "100%",
    height: 400,
    overflowY: "auto",
  },
  cardBtn: {
    width: "100%",
  },
});
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const csvData = [
  ["firstname", "lastname", "email"],
  ["Ahmed", "Tomi", "ah@smthing.co.com"],
  ["Raed", "Labes", "rl@smthing.co.com"],
  ["Yezzi", "Min l3b", "ymin@cocococo.com"],
];

const Copy = observer(
  class Init extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        checked: false,
      };
    }

    componentDidMount = async () => {
      locationStore.getLocationList();
    };

    fileHandler = (event) => {
      let fileObj = event.target.files[0];

      //just pass the fileObj as parameter
      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          this.alert.show(err);
        } else {
          store.setCols(resp.cols);
          store.setRows(resp.rows);
        }
      });
    };
    handleSwitch = (e) => {
      this.setState({
        [e.target.name]: e.target.checked,
      });
    };

    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };

    handleClick = () => {
      if (this.state.url && this.state.loc) {
        store.startJob(this.state.url, this.state.loc);
      } else {
        this.props.alert.show("입력창 확인.");
      }
    };

    render() {
      const { classes } = this.props;
      const { search } = this.state;
      const { rows, cols, isLoading, jobCount, blocking, status } = toJS(store);
      const { locationList } = toJS(locationStore);
      let filterList = locationList
        .filter((location) => location.url)
        .sort(function (a, b) {
          return a.locname < b.locname ? -1 : a.locname > b.locname ? 1 : 0;
        });
      const val = parseInt((jobCount / rows.length) * 100) || 0;
      if (search) {
        filterList = filterList.filter(
          (location) => location.locname.indexOf(search) > -1
        );
      }
      return (
        <Layout>
          <h2>복본체크</h2>

          <div class='tRender'>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={this.handleSwitch}
                name="checked"
                color="primary"
              />
            }
            label="테이블렌더링(성능저하)"
          />
          </div>
          <Collapse in={this.state.checked}>
          <div class='renderCol'>
              <Card className={classes.excel}>
                <CardContent>
                  {rows && cols && this.state.checked && (
                    <OutTable
                    data={rows}
                    columns={cols}
                    tableClassName="ExcelTable2007"
                    tableHeaderRowClass="heading"
                    />
                    )}
                </CardContent>
              </Card>
          </div>
          </Collapse>
          <Grid container spacing={3}>
            <div class='fileChk'>
              {/* <CopyForm /> */}
              <div className={classes.cardDiv}>
                <Card elevation={5}>
                  <CardHeader title="복본체크" />
                  <CardContent>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="url"
                      label={this.state.url ? "" : "url"}
                      type="text"
                      id="url"
                      value={this.state.url}
                      onChange={this.handleChange}
                      disabled={blocking}
                    />
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="loc"
                      label={this.state.url ? "" : "loc"}
                      type="text"
                      id="loc"
                      value={this.state.loc}
                      onChange={this.handleChange}
                      disabled={blocking}
                    />
                    {!blocking && (
                      <input
                        type="file"
                        onChange={this.fileHandler.bind(this)}
                        style={{ padding: "10px" }}
                      />
                    )}
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.cardBtn}
                      onClick={this.handleClick}
                      disabled={
                        blocking ||
                        rows.length <= 0 ||
                        this.state.loc === undefined ||
                        this.state.url === undefined
                      }
                    >
                      시작하기
                    </Button>
                  </CardActions>
                </Card>
              </div>
            </div>

            <div class='locChk'>
              <Card elevation={5} className={classes.cardDiv}>
                <CardHeader title="기관" />
                <CardContent>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="search"
                    label={this.state.url ? "" : "검색"}
                    type="text"
                    id="search"
                    value={this.state.search}
                    onChange={this.handleChange}
                    disabled={blocking}
                  />
                  {filterList.map((location) => (
                    <Button
                      key={location.loc}
                      variant="contained"
                      color="primary"
                      className={classes.btn}
                      style={{ margin: 10 }}
                      disabled={blocking}
                      onClick={() => {
                        this.setState((state) => ({
                          url: location.url,
                          loc: location.loc,
                        }));
                      }}
                    >
                      {location.locname}
                    </Button>
                  ))}
                </CardContent>
              </Card>
            </div>


            <div class='chkStatus'>
              <Card elevation={5} className={classes.cardDiv}>
                <CardHeader title="상태창" />
                <CardContent>
                  <h2>상태: {blocking && "작업중"}</h2>
                  <h2>전체 작업 수: {rows.length}</h2>
                  <h2>작업완료 : {jobCount}</h2>
                  <LinearProgressWithLabel
                    value={val}
                  ></LinearProgressWithLabel>
                  {/* {rows && cols && (
              <OutTable
                data={rows}
                columns={cols}
                tableClassName="ExcelTable2007"
                tableHeaderRowClass="heading"
              />
            )} */}
                  {status === "end" && (
                    <CSVLink
                      data={rows}
                      filename={"copyCheck.csv"}
                      className="btn btn-primary"
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                      >
                        Save CSV
                      </Button>
                    </CSVLink>
                  )}
                </CardContent>
              </Card>
            </div>
          </Grid>

          
          
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(Copy);
export default withStyles(styles)(alertView);
